var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerSmallDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.484,
    height: 50.589,
    viewBox: "0 0 33.484 50.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M440.119,342.314a16.776,16.776,0,0,0-16.74,16.74c-.106,10.118,5.138,17.587,10.7,25.428,1.854,2.543,3.708,5.245,5.455,8.1a.61.61,0,0,0,.582.318.73.73,0,0,0,.581-.318c1.748-2.808,3.655-5.508,5.509-8.157,5.509-7.84,10.859-15.257,10.649-25.321a16.783,16.783,0,0,0-16.737-16.793Z",
    transform: "translate(-423.377 -342.314)",
    fill: "#001233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSmallDark);
export default __webpack_public_path__ + "static/media/marker-small-dark.8d629ffaf1f498ed23b575add0e3b264.svg";
export { ForwardRef as ReactComponent };